// ReactivationEntryCard — discoverable entry into the reactivation feed.
// Reactivation isn't a bottom-nav tab (TZ §3.2 only added «Звонки»), so each
// role reaches it from their home: managers from /today, directors from
// /dashboard. Self-contained navigation so host screens stay untouched.
import { useNavigate } from 'react-router-dom'

import { useAiFeatures } from '../api/features'
import { Icon, t } from '../design'

export function ReactivationEntryCard() {
  const navigate = useNavigate()
  const features = useAiFeatures()
  // Director can disable reactivation for the team → hide the entry entirely.
  if (!features.reactivation) return null
  return (
    <button
      onClick={() => navigate('/reactivation')}
      className="card card-16"
      style={{
        width: '100%', textAlign: 'left', cursor: 'pointer', border: 'none',
        marginBottom: 12, display: 'flex', alignItems: 'center', gap: 12,
      }}
    >
      <span style={{
        width: 40, height: 40, borderRadius: 11, flexShrink: 0,
        background: 'var(--ai-bg)', color: 'var(--ai)',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <Icon.Recycle size={20} sw={2} />
      </span>
      <div className="flex-1" style={{ minWidth: 0 }}>
        <div className="t-body-s">{t('react.title')}</div>
        <div className="t-caption">{t('re.entryHint')}</div>
      </div>
      <Icon.ArrowRight size={18} sw={2} style={{ color: 'var(--text-3)' }} />
    </button>
  )
}
